/** True when a taxonomy slug is entirely decimal digits, such as "777". */
export const isNumericOnlySlug = (value: unknown): boolean => {
  if (typeof value !== "string") {
    return false;
  }
  const slug = value.trim();
  return slug.length > 0 && /^[0-9]+$/.test(slug);
};
